import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { appApiResources } from '../../../configuration/app.constants';

@Injectable({
  providedIn: 'root'
})
export class GetStateService {

  constructor(private http: HttpClient) { }

  async getAllState() {
    try {
      let response = await this.http
        .get(`${appApiResources.getState}`)
        .toPromise();
      return response;
    } catch (error) {
      return error;
    }
  }
}
